﻿//our root app component
import {Component, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { ContextService } from '../../../@core/services/context-service';
import { LoggerService } from '../../../@core/services/logger-service';
import { SpinnerService } from '../../../@core/services/spinner-service';
import { ContextInfo } from '../../models/context-info';

@Component({
    selector: 'file-upload',
    templateUrl: 'fileupload.tmpl.html'
})

export class FileUploadComponent {
    constructor(private loggerService: LoggerService, private contextService: ContextService,
        private spinnerService: SpinnerService) { }

    currentUser: ContextInfo;

    @Output("fileSelected")
    fileSelected = new EventEmitter();

    @ViewChild('fileChoose') fileChoose: ElementRef; 

    reset() {
        this.fileChoose.nativeElement.value = null;
    }

    filechosen($event): void {
        var self = this;
        this.loggerService.logData($event.target);
        var file = $event.target.files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
            var buffer = reader.result;
            var binary = '';
            var bytes = new Uint8Array(<ArrayBuffer>buffer);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            var base64Content = window.btoa(binary);
            self.loggerService.logData(base64Content);

            var retVal = { base64Response: base64Content, mimeType: file.type, fileName: file.name, fileSize: len };
            self.fileSelected.emit(retVal);
        }
        reader.readAsArrayBuffer(file);
    }
}